import axios from '../../../../utils/request';

function GET_WEBSITE() {
    return axios.get("/admin/APromotionWebsite/index" )
}
function SET_SITEINFO(params) {
    return  axios.post("/admin/APromotionWebsite/editPost", params  )
}

export default {
    GET_WEBSITE,
    SET_SITEINFO,

};